<template>
    <b-row>
        <b-col>
            <b-spinner v-if="integrating"></b-spinner>
            <b-row v-else>
                <!-- Status badge -->
                <b-col cols="12" class="mb-2">
                    <b-badge :variant="isActive ? 'success' : 'secondary'" class="integration-status-badge">
                        {{ isActive ? $t('active') : $t('notActive') }}
                    </b-badge>
                </b-col>

                <template v-if="isActive">
                    <b-col cols="12" md="auto" v-if="canDeactivate">
                        <b-button variant="outline-warning" size="sm" @click="deactivate()">{{ $t('deactivate') }}</b-button>
                    </b-col>
                </template>
                <template v-else>
                    <b-col cols="12" md="4" v-if="canShowBuy"><protokol-checkout-button productType="integration" :reference="integration.id" block></protokol-checkout-button></b-col>
                    <b-col cols="12" md="4" v-if="canShowTrial"><b-button variant="primary" class="ml-2" @click="startTrial" block>{{ $t('startTrial') }}</b-button></b-col>
                    <b-col cols="12" md="4" v-if="canShowInstall"><b-button class="ml-2" variant="primary" @click="activate()">{{ $t('activate') }}</b-button></b-col>
                </template>
            </b-row>
        </b-col>
    </b-row>
</template>

<style scoped>
.integration {
    text-align: center;
    cursor: pointer;
}

.integration h4 {
    font-size: 18px;
    margin-top: 10px;
}

.integration-status-badge {
    font-size: 0.75rem;
    padding: 0.35em 0.65em;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
</style>

<script>
export default {
    name: 'StartTrialFooter',
    props: {
        integration: {
            type: Object
        },
        autoIntegrate: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            integrating: false
        }
    },
    computed: {
        isFree() {
            return this.price.price == 0
        },

        canShowTrial() {
            const isTrialUsed = this.$store.getters.isTrialUsed(this.integration.product_id)
            if (isTrialUsed) {
                return false
            }

            let subs = this.$store.getters.getSubscriptions || []

            let integrationSub = subs.find(s => {
                return s.product_id == this.integration.product_id
            })

            return !integrationSub
        },

        canShowBuy() {
            let subs = this.$store.getters.getSubscriptions || []

            let integrationSub = subs.find(s => {
                return s.product_id == this.integration.product_id
            })

            if (integrationSub && integrationSub.is_trial) {
                return true
            }

            return integrationSub === undefined
        },

        canShowInstall() {
            let subs = this.$store.getters.getSubscriptions || []
            let valid = subs.find(s => {
                return s.product_id == this.integration.product_id
            })

            return this.isFree || valid !== undefined
        },

        canDeactivate() {
            const integration = this.$store.getters.getIntegrationByID(this.integration.id)

            return integration.dependencies.length == 1 && integration.dependencies[0] == "platform"
        },

        isActive() {
            return this.$store.getters.isIntegrationActive(this.integration.id)
        }
    },

    methods: {
        installInProgress() {
            this.$store.dispatch("fetchIntegrations", true).then(() => {
                if (this.$store.getters.isIntegrationActive(this.integration.id)) {
                    this.integrating = false

                    this.$emit("activate", this.integration)
                } else {
                    setTimeout(this.installInProgress, 3000)
                }
            })
        },

        async activate() {
            let confirm = await this.$mainDialog.msgBoxConfirm(this.$t('integrations.activateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;

                this.$store.dispatch("activateIntegration", this.integration).then(() => {
                    setTimeout(this.installInProgress, 1000)
                }).catch(err => {
                    this.$debugLog(err)
                    this.$mainDialog.msgBoxOk(`${this.$t('failedToInstall')}.`)
                    this.integrating = false
                })

                return;
            }

        },

        async deactivate() {
            let confirm = await this.$mainDialog.msgBoxConfirm(this.$t('integrations.deactivateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;
                
                this.$store.dispatch("deactivateIntegration", this.integration).catch(err => {
                    this.$debugLog(err)

                    if (err.response) {
                        console.log(err.response)
                        if (err.response.status == 409) {
                            this.$mainDialog.msgBoxOk(this.$t(err.response.data.message))
                            return
                        }
                    }

                    this.$mainDialog.msgBoxOk(`${this.$t('failedToRemove')}.`)
                }).finally(() => {
                    this.integrating = false
                })

                return
            }

            this.$emit("deactivate", this.integration)
        },

        startTrial() {
            const popup = this.$loadingPopup()
            this.$transactions.startTrial({
                product_type: "integration",
                reference: this.integration.id,
                source: "platform"
            }).then((resp) => {
                this.$bvToast.toast(this.$t('trialIsNowActive'), {
                    variant: 'success',
                    title: this.$t('success')
                })

                resp.data.forEach(d => {
                    this.$store.commit("ADD_TRIAL", d)
                })

                this.$store.dispatch("fetchSubscriptions", true)
            }).catch((err) => {
                this.$debugLog()
                this.$bvToast.toast(this.$t('failedToStartTrial'), {
                    variant: 'danger',
                    title: this.$t('error')
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    async mounted() {
        await this.$store.dispatch("fetchSubscriptions", true)
        await this.$store.dispatch("fetchTrials")
    }
}
</script>